/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import $ from 'jquery'
import Config from 'theme/config'
import find from 'lodash/find'
import compact from 'lodash/compact'
import minBy from 'lodash/minBy'
import isEmpty from 'lodash/isEmpty'
import each from 'lodash/each'
import sortBy from 'lodash/sortBy'

/**
 * Create slugify -> "create-slugify" permalink  of text
 * @param {String} text
 */
export function slugify (text) {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
}

/**
 * check if browser is online or not
 */
export function isOnline () {
  if (typeof navigator !== 'undefined') {
    return navigator.onLine
  } else {
    return true // SSR
  }
}

/**
 * @param relativeUrl
 * @param width
 * @param height
 * @returns {*}
 */
export function getThumbnailPath (relativeUrl, size) {
  if (relativeUrl && (relativeUrl.startsWith('http') || relativeUrl.startsWith('//'))) {
    return relativeUrl
  }
  return relativeUrl && relativeUrl.indexOf('no_selection') < 0 ? `${Config.API.img['entryPoint' + size]}${relativeUrl}` : Config.API.img.placeholder || ''
}

export function getCategoriesFromPath (path, flatted) {
  if (!(path && path.length)) {
    return []
  }
  const paths = []
  const splittedPath = path.split('/')

  let incrementPath = ''
  let category
  for (let i in splittedPath) {
    incrementPath += (Number(i) === 0 ? '' : '/') + splittedPath[i]
    category = find(flatted, { url_path: incrementPath, is_active: true })
    if (category) {
      paths.push(category)
    }
  }
  return paths
}

export function mapAddress (address) {
  const formatAddress = {
    region: address.region.name || '',
    region_id: Number(address.region.region_id),
    region_code: address.region.region_code,
    country_id: address.country_id,
    street: address.street.length ? address.street : [],
    telephone: address.telephone,
    postcode: address.postcode,
    city: address.city,
    firstname: address.firstname,
    lastname: address.lastname
  }
  if (address.company || address.vat_id) {
    formatAddress.company = address.company
    formatAddress.vat_id = address.vat_id
  }
  return formatAddress
}

export function mapCheckoutAddress (address, isBilling, $store) {
  if (address.useotheraddress) {
    address = { ...address, ...$store.state.checkout[ isBilling ? 'shippingAddress' : 'billingAddress' ] }
  }
  const email = $store.getters['user/isLogged'] ? $store.state.user.current.email : $store.state.user.guest.email
  let region = $store.getters['checkout/getRegionByCode']({ regionCode: address.region.region_code, countryID: address.country_id })
  const formatAddress = {
    region: region.name,
    regionId: Number(region.id),
    regionCode: region.code,
    countryId: address.country_id,
    street: address.street,
    telephone: address.telephone,
    postcode: address.postcode,
    city: address.city,
    firstname: address.firstname,
    lastname: address.lastname,
    email: email,
    saveInAddressBook: 0
  }
  if (isBilling) {
    formatAddress.company = $store.state.checkout.billingAddress.company
    formatAddress.vatId = $store.state.checkout.billingAddress.vat_id
  }
  return formatAddress
}

export function getSuffixGuest (rootGetters) {
  return rootGetters['user/isLogged'] ? '' : 'Guest'
}

export function processInclude (obj) {
  if (typeof obj === 'object') {
    for (let key in obj) {
      if (typeof obj[key] === 'function') {
        obj[key]()
      }
    }
  }
  if (typeof obj === 'function') {
    obj()
  }
}

export function minMaxFromPriceArr (valueArr) {
  var min, max, tmpMin, tmpMax
  valueArr.forEach(val => {
    [tmpMin, tmpMax] = val.split('_')
    tmpMin = parseInt(tmpMin)
    tmpMax = tmpMax !== '*' ? parseInt(tmpMax) : Infinity
    if (min === undefined) {
      min = tmpMin
      max = tmpMax
    } else {
      if (tmpMin < min) {
        min = tmpMin
      }
      if (tmpMax > max) {
        max = tmpMax
      }
    }
  })
  return {
    from: min,
    to: max === Infinity ? '' : max
  }
}

function getPriceByAttr (priceRange, minAttr, maxAttr, typePrice) {
  if (priceRange && priceRange[minAttr]) {
    return {
      min: priceRange[minAttr],
      max: priceRange[maxAttr],
      currency: priceRange[minAttr][typePrice].currency
    }
    // return {
    //   min: priceRange[minAttr][typePrice].value,
    //   max: priceRange[maxAttr][typePrice].value,
    //   currency: priceRange[minAttr][typePrice].currency
    // }
  } else {
    return {
      min: NaN,
      max: NaN,
      currency: null
    }
  }
}

export function getMinimumPriceProducts (products) {
  if (products) {
    let minFromProducts = minBy(products, function (product) {
      let min = product.price_range.minimum_price.final_price.value
      let tierArray = []
      if (product.price_tiers && product.price_tiers.length) {
        product.price_tiers.forEach(tier => {
          if (tier.quantity <= 1) {
            tierArray.push(tier.final_price.value)
          }
        })
      }
      return Math.min(...compact([min, ...tierArray]))
    })
    return minFromProducts
  }
  return null
}

export function getRangePriceFromProduct (product) {
  let min = NaN
  let max = NaN
  let currency = null
  if (product.price_range) {
    return getPriceByAttr(product.price_range, 'minimum_price', 'maximum_price', 'final_price')
  }
  return {
    min,
    max,
    currency
  }
}

export function fromSlugToText (slug) {
  return toCapitalize(slug)
}

export function toCapitalize (str) {
  let strSplitted = str.split(' ')
  return strSplitted.map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(' ')
}

export function getBreadcrumbFromURL ({ fullPath, title, translate, i18nObj = {} }) {
  // remove last '/' empty
  if (fullPath.charAt(fullPath.length - 1) === '/') {
    fullPath = fullPath.substring(0, fullPath.length - 1)
  }
  let pathSpitted = fullPath.split('/')
  let paths = [{
    text: translate ? translate('home') : 'Home',
    to: { name: 'home' },
    exact: true
  }]
  for (let i = 2; i < pathSpitted.length - 1; i++) {
    paths.push({
      text: translate ? translate('route.' + pathSpitted[i]) : fromSlugToText(pathSpitted[i]),
      to: pathSpitted.slice(0, i + 1).join('/'),
      exact: true
    })
  }
  title = title || pathSpitted[pathSpitted.length - 1]
  paths.push({
    text: translate ? translate('route.' + title, i18nObj) : title,
    active: true
  })
  return paths
}

export function graphqlManageError (resp) {
  if (resp && resp.errors && resp.errors.length) {
    if (resp.errors[0].debugMessage) {
      return resp.errors[0].debugMessage
    }
    return resp.errors[0].message
  }
  return false
}

export function apiManageError (message, parameters) {
  let msg = message
  if (parameters) {
    for (let key in parameters) {
      msg = msg.replace('%' + key, parameters[key])
    }
  }
  return msg
}

export function scrollTo ({ top = null, className, block = 'center' }) {
  if (className) {
    document.getElementsByClassName(className)[0]
      .scrollIntoView({ behavior: 'smooth', block })
  } else if (top !== null) {
    document.querySelector('html').scrollTo({ top, left: 0, behavior: 'smooth' })
  }
}

export function encodeScriptTag (str) {
  return str ? str.replace(/</g, '&lt;').replace(/>/g, '&gt;') : str
}

export function decodeScriptTag (str) {
  return str ? str.replace(/&lt;/g, '<').replace(/&gt;/g, '>') : str
}

export function findActiveCountry (countries, currentCountry = null, stateArea, storeView) {
  if (currentCountry) {
    return find(countries[stateArea], { country: currentCountry, store_view: storeView })
  } else {
    return find(countries[stateArea], (country) => {
      return find(country.locales, { 'store_view': storeView })
    })
  }
}

export function giftCardFormDecorator ({ product, giftOptions, getFromOptions = false }) {
  // getFromOption
  // get info (amount | template) from giftOption if user have setted before and not from product
  // by default this option is false
  // note: is used in wishlist -> on add giftcard
  return {
    aw_gc_amount: (getFromOptions) ? giftOptions.aw_gc_amounts : product.aw_gc_amounts[0],
    aw_gc_template: (getFromOptions) ? giftOptions.aw_gc_template : product.aw_gc_email_templates[0].value,
    aw_gc_delivery_date: giftOptions.aw_gc_delivery_date,
    aw_gc_delivery_date_timezone: '',
    aw_gc_recipient_name: giftOptions.aw_gc_recipient_name,
    aw_gc_recipient_email: giftOptions.aw_gc_recipient_email,
    aw_gc_sender_name: giftOptions.aw_gc_sender_name ? giftOptions.aw_gc_sender_name : giftOptions.aw_gc_recipient_name,
    aw_gc_sender_email: giftOptions.aw_gc_sender_email ? giftOptions.aw_gc_sender_email : giftOptions.aw_gc_recipient_email,
    aw_gc_headline: giftOptions.aw_gc_headline,
    aw_gc_message: giftOptions.aw_gc_message
  }
}

export function getCurrentPrice (product) {
  let priceInfo = {
    current: 0,
    regularPrice: 0,
    discount: 0
  }
  let rangePrice = getRangePriceFromProduct(product)
  if (product.special_price) {
    priceInfo.current = product.special_price
  } else if (rangePrice.min && (rangePrice.min.regular_price.value === rangePrice.max.regular_price.value)) {
    priceInfo.current = rangePrice.min.final_price.value
  } else {
    // has price range
    priceInfo.current = rangePrice.min.final_price.value
  }
  // has discount
  if (rangePrice.min && (rangePrice.min.final_price.value !== rangePrice.min.regular_price.value)) {
    // priceObj.regularPrice = this.$t('Regular Price {price}', { price: filterPrice(rangePrice.max.regular_price.value) })
    priceInfo.regularPrice = rangePrice.max.regular_price.value
    priceInfo.discount = rangePrice.min.discount
  }
  return priceInfo
}

export function getCurrentPriceNoTax (product) {
  let priceInfo = {
    current: 0,
    regularPrice: 0,
    discount: 0
  }
  let rangePrice = getRangePriceFromProduct(product)
  if (product.special_price) {
    priceInfo.current = product.special_price
  } else if (rangePrice.min.regular_price.value === rangePrice.max.regular_price.value) {
    priceInfo.current = rangePrice.min.final_price.value
  } else {
    // has price range
    priceInfo.current = rangePrice.min.final_price.value
  }
  // has discount
  if (rangePrice.min.final_price.value !== rangePrice.min.regular_price.value) {
    // priceObj.regularPrice = this.$t('Regular Price {price}', { price: filterPrice(rangePrice.max.regular_price.value) })
    priceInfo.regularPrice = rangePrice.max.regular_price.value
    priceInfo.discount = rangePrice.min.discount
  }
  return priceInfo
}

export function resizeService (url, opt) {
  let _url = url
  if (url && url.startsWith('//')) {
    url = 'https:' + url
  }
  if (url && url.startsWith(process.env.VUE_APP_MAGENTO)) {
    _url = url.replace(process.env.VUE_APP_MAGENTO, Config.API.img.resizeUrl)
  }
  if (opt && Object.keys(opt).length) {
    _url += '?'
    for (let key in opt) {
      _url += `&${key}=${opt[key]}`
    }
  }
  return _url
}

export function manageAttributesLabel (attributesLabel) {
  const IsJsonString = (str) => {
    try {
      JSON.parse(str)
    } catch (e) {
      return false
    }
    return true
  }
  let response = attributesLabel
  if (attributesLabel && attributesLabel.length) {
    let attrMap = {}
    attributesLabel.forEach(item => {
      attrMap[item.attribute_code] = { ...item }
      attrMap[item.attribute_code].value = (IsJsonString(item.value) ? JSON.parse(item.value) : item.value)
    })
    response = attrMap
  }
  return response
}

export function isMobile () {
  return $(window).width() < Config.Theme.widthMobile
}

export function isGroupedProduct (product) {
  return product && product.__typename && product.__typename === 'GroupedProduct'
}

export function mapCheckoutAddressGraph (address, isBilling, rootStore, rootGetter) {
  let region = rootGetter['checkout/getRegionByCode']({ regionCode: address.region.region_code, countryID: address.country_id })
  const formatAddress = {
    ID: address.ID || '',
    city: address.city,
    company: '',
    country_code: address.country_id,
    region: region.code,
    region_id: Number(region.id),
    firstname: address.firstname,
    lastname: address.lastname,
    postcode: address.postcode,
    street: address.street,
    telephone: address.telephone,
    save_in_address_book: false
  }
  if (isBilling) {
    // formatAddress.company = $store.state.checkout.billingAddress.company
    formatAddress.vat_id = address.vat_id
  }
  return formatAddress
}

export function axiosErrorMessage (error, defaultMsg = 'GenericError') {
  if (error && error.errors) {
    return graphqlManageError(error)
  }
  let msg = defaultMsg
  if (error.response && error.response.data && error.response.data.message) {
    msg = apiManageError(error.response.data.message, error.response.data.parameters)
  }
  if (error.body && error.body.result) {
    msg = error.body.result
  }
  return msg
}

export function randomInRange (min = 10, max = 100) {
  return Math.floor(Math.random() * (max - min + 1)) + max
}

function getConfigurableOptMap (configurableOptions) {
  let map = {}
  let options = configurableOptions
  if (options) {
    options.forEach(confOpt => {
      map[confOpt.attribute_id] = confOpt.attribute_code
    })
  }
  return map
}

export function getVariantByFilter (skip = 'size', filterActive, product) {
  let options = []
  let skipDuplicate = {}
  let filter = isEmpty(filterActive) ? {} : filterActive
  let confMap = getConfigurableOptMap(product.configurable_options)
  let variants = product.variants
  let exitFor
  let attributeMap
  if (variants) {
    for (let i in variants) {
      exitFor = false
      attributeMap = {}
      if (variants[i].attributes.length) {
        each(variants[i].attributes, item => {
          attributeMap[item.code] = item
        })
        if (!skipDuplicate[attributeMap[skip]]) {
          for (let key in filter) {
            if (confMap[key] !== skip) {
              if (attributeMap[confMap[key]].value_index !== filter[key]) {
                exitFor = true
                break
              }
            }
          }
          if (!exitFor) {
            options.push({
              label: attributeMap[skip].label,
              value: attributeMap[skip].value_index,
              value_index: attributeMap[skip].value_index,
              is_pre_order: variants[i].product.is_preorder,
              is_backinstock: variants[i].product.is_backinstock,
              min_qty: variants[i].product.out_of_stock_threshold,
              quantity: variants[i].product.quantity,
              in_stock: variants[i].product.quantity > 0
            })
            skipDuplicate[attributeMap[skip].value_index] = true
          }
        }
      }
    }
  }
  let sortedOption = sortBy(options, ['label'])
  return sortedOption
}

export function getProductCategory (product, $store) {
  // last breadcrumb
  let lastCategories = $store.state.ui.breadcrumb.length ? $store.state.ui.breadcrumb[$store.state.ui.breadcrumb.length - 1].text : ''
  return lastCategories
}
